<template>
    <!-- 素材区组件 action  -->
    <div class="action" id="ACTION-SWF">
        <div class="mask_action" v-show="mask_visible"></div>
        <div v-loading="loading" v-show="loading && 0 == public_list_data.length " element-loading-text="" element-loading-background="#3a3a3a" class="loading"></div>
        <!-- 切换标签组件 tabs -->
        <div class="tabs">
            <div
            v-for="item, index in tab_tab"
            :class="{'active':item.active}"
            @click="handleTabChange(index)">
            {{item.name}}
        </div>
        </div>
        <!-- 搜索组件 search @focus="searchInputFocus" @blur="searchInputBlur"-->
        <div class="search" :class="searchHide">
            <div class="search-inner">
                <input type="text" class="text" placeholder="请输入素材名称、版权方、标签" @keyup.13="handdleStartSearch('1')" v-model="search_key" >
                <span class="icon-search button" @click="handdleStartSearch('1')"></span>
                <span class="el-icon-close button" @click="handleCloseSearch('1')" v-show="search_key.length > 0"></span>
            </div>
        </div>
        <!-- <div class="select_action_tips" style="background:red;" v-show="select_action_tips.length > 0" >已选动作: {{select_action_tips}}</div> -->
        <!-- 组合动作按钮 -->
        <!-- <div class="group_btn" v-show="action_type != 'bubble' && action_type != 'prop' && !search_status" style="background:red;">
            <el-button size="mini" style="margin-left: 10px;" type="normal" @click="handleGroupShow()" v-show="!group_status">组合动作</el-button>
            <el-button type="text" size="mini" icon="arrow-left" style="color:#666;" @click="handleGroupHide()" v-show="group_status">返回</el-button>
        </div> -->
        <!-- 公共市场 -->
        <div class="public" :class="positionTop1" v-if="tab_tab_init == 'public' && !group_status">
            <!-- 素材分类组件 category -->
            <div class="category-type" v-show="!search_status && tab_left_pancel.length != 1">
                <div v-for="item, index in tab_left_pancel" :class="{'active':item.active}" @click="handleLeftPancelChange(index)" :title="item.name">
                   <span>{{item.name}}</span>
                </div>
            </div>
        <!-- 素材列表组件 list -->
        <div class="list" v-show="!no_result" :class="hideLeft">
            <div class="con">
                <div class="item" :class="positionWidth" v-for="item, index in public_list_data" @mousedown="handlePublicItemDown(item, $event)"  @mouseup="handlePublicItemUp(item, $event)">
                    <div class="name" :title="item.title">{{item.title}}</div>
                    <div class="group" v-if="item.extdata && item.extdata.movable !== null">
                        <i class="icon-action_move" v-if="item.extdata.movable && item.extdata.looped"></i>
                        <i class="icon-action_circulation" v-if="item.extdata.looped === true && item.extdata.movable === false"></i>
                        <i class="icon-action_time" v-if="item.extdata.movable === false || item.extdata.looped === false"></i>
                        <span  v-if="item.extdata.movable === false || item.extdata.looped === false">{{item.extdata.duration.toFixed(2)}}秒</span>
                    </div>
                </div>
            </div>
            <!-- <div class="more" @click="handleMore" v-show="more">
                <div class="inner">加载更多</div>
            </div>
            <div class="loadingMore" v-show="loading && 1 <  current_page">
                    <svg style="margin-left:40%;"width="35" height="30" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" fill="#FF4F53">
                        <circle cx="15" cy="15" r="15">
                            <animate attributeName="r" from="15" to="15"
                            begin="0s" dur="0.8s"
                            values="15;9;15" calcMode="linear"
                            repeatCount="indefinite" />
                            <animate attributeName="fill-opacity" from="1" to="1"
                            begin="0s" dur="0.8s"
                            values="1;.5;1" calcMode="linear"
                            repeatCount="indefinite" />
                        </circle>
                        <circle cx="60" cy="15" r="9" fill-opacity="0.3">
                            <animate attributeName="r" from="9" to="9"
                            begin="0s" dur="0.8s"
                            values="9;15;9" calcMode="linear"
                            repeatCount="indefinite" />
                            <animate attributeName="fill-opacity" from="0.5" to="0.5"
                            begin="0s" dur="0.8s"
                            values=".5;1;.5" calcMode="linear"
                            repeatCount="indefinite" />
                        </circle>
                        <circle cx="105" cy="15" r="15">
                            <animate attributeName="r" from="15" to="15"
                            begin="0s" dur="0.8s"
                            values="15;9;15" calcMode="linear"
                            repeatCount="indefinite" />
                            <animate attributeName="fill-opacity" from="1" to="1"
                            begin="0s" dur="0.8s"
                            values="1;.5;1" calcMode="linear"
                            repeatCount="indefinite" />
                        </circle>
                    </svg>
                </div>-->
                <!-- 分页控件的占位高度 -->
                <div style="position:relation:width:100%;height:20px;"></div>
            </div>

            <!-- 分页控件 -->
            <div class="loadingMore" v-show="tab_left_pancel_init != 'bgc'" v-if="!no_result">
                <el-pagination class="pagination" small
                @current-change="handleCurrentChange"
                :page-size="20"
                :pager-count="5"
                layout="prev, pager, next"
                :total="pagination_list_count" >
                </el-pagination>
            </div>
        </div>
        <!-- 我的 -->
        <div class="private-team" :class="positionTop" v-if="tab_tab_init == 'self' && !group_status">

            <!-- 素材分类组件 category -->
            <div class="category-type" v-show="!search_status && tab_left_pancel.length != 1">
                <div
                v-for="item, index in tab_left_pancel"
                :class="{'active':item.active}"
                @click="handleLeftPancelChange(index)">
                {{item.name}}
            </div>
        </div>
        <!-- 面包屑组件 -->
        <div class="breadcrumb">
            <span v-show="breadcrumb.length > 1"
                v-for="item, index in breadcrumb"
                @click="handleTargetNav(index, item.folder_id)">{{item.name == '我的' ? item.name : '/ ' + item.name}}</span>
            </div>
            <!-- 素材列表组件 list -->
            <div class="list" v-show="!no_result" :class="hideLeft">
                <div class="con">
                    <div class="item" :class="positionWidth" v-for="item in self_list_data" v-if="this.tab_left_pancel_init = 'buy'" v-show="item.count != 0" @click="handleSelfTeamItem(item)">
                        <div v-show="item.type == 'folder' | item.type == 'package'" class="folder">
                            <div class="pic"><img src="./folder.png"></div>
                            <div class="name">{{item.title}}</div>
                        </div>
                        <div v-show="item.type != 'folder' && item.type != 'package'" class="file">
                            <div class="name" :title="item.title">{{item.title}}</div>
                            <div class="group" v-if="item.extdata && item.extdata.movable !== null">
                                <i style="color:#e2e2e2;" class="icon-action_move" v-if="item.extdata.movable && item.extdata.looped"></i>
                                <i style="color:#e2e2e2;" class="icon-action_circulation" v-if="item.extdata.looped === true && item.extdata.movable === false"></i>
                                <i style="color:#e2e2e2;" class="icon-action_time" v-if="item.extdata.movable === false || item.extdata.looped === false"></i>
                                <span  style="color:#e2e2e2;" v-if="item.extdata.movable === false || item.extdata.looped === false">{{item.extdata.duration.toFixed(2)}}秒</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="more" @click="handleMore" v-show="more">
                    <div class="inner">加载更多</div>
                </div> -->
                <!-- 分页控件的占位高度 -->
                <div style="position:relation:width:100%;height:20px;"></div>
            </div>

            <!-- 分页控件 -->
            <div class="loadingMore" v-show="tab_left_pancel_init != 'bgc'" v-if="!no_result">
                <el-pagination class="pagination" small
                @current-change="handleCurrentChange"
                :page-size="20"
                :pager-count="5"
                layout="prev, pager, next"
                :total="pagination_list_count" >
                </el-pagination>
            </div>
        </div>
        <!-- 团队 -->
        <div class="private-team" :class="positionTop" v-if="tab_tab_init == 'team' && !group_status">
            <!-- 素材分类组件 category -->
            <div class="category-type" v-show="!search_status && tab_left_pancel.length != 1">
                <div
                v-for="item, index in tab_left_pancel"
                :class="{'active':item.active}"
                @click="handleLeftPancelChange(index)">
                {{item.name}}
            </div>
        </div>
        <!-- 面包屑组件 -->
        <div class="breadcrumb">
            <span v-show="breadcrumb.length > 1"
                v-for="item, index in breadcrumb"
                @click="handleTargetNav(index, item.folder_id)">{{item.name == '我的' ? item.name : '/ ' + item.name}}</span>
            </div>
            <!-- 素材列表组件 list -->
            <div class="list" v-show="!no_result" :class="hideLeft">
                <div class="con">
                    <div class="item" :class="positionWidth" v-for="item in team_list_data" v-if="this.tab_left_pancel_init = 'buy'" v-show="item.count != 0" @click="handleSelfTeamItem(item)">
                        <div v-show="item.type == 'folder' |item.type == 'package'" class="folder">
                            <div class="pic"><img src="./folder.png"></div>
                            <div class="name">{{item.title}}</div>
                        </div>
                        <div v-show="item.type != 'folder' && item.type != 'package'" class="file">
                            <div class="name" :title="item.title">{{item.title}}</div>
                            <div class="group" v-if="item.extdata && item.extdata.movable !== null">
                                <i style="color:#e2e2e2;" class="icon-action_move" v-if="item.extdata.movable && item.extdata.looped"></i>
                                <i style="color:#e2e2e2;" class="icon-action_circulation" v-if="item.extdata.looped === true && item.extdata.movable === false"></i>
                                <i style="color:#e2e2e2;" class="icon-action_time" v-if="item.extdata.movable === false || item.extdata.looped === false"></i>
                                <span  style="color:#e2e2e2;" v-if="item.extdata.movable === false || item.extdata.looped === false">{{item.extdata.duration.toFixed(2)}}秒</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="more" @click="handleMore" v-show="more">
                    <div class="inner">加载更多</div>
                </div> -->
                <!-- 分页控件的占位高度 -->
                <div style="position:relation:width:100%;height:20px;"></div>
            </div>
            <!-- 分页控件 -->
            <div class="loadingMore" v-show="tab_left_pancel_init != 'bgc'" v-if="!no_result">
                <el-pagination class="pagination" small
                @current-change="handleCurrentChange"
                :page-size="20"
                :pager-count="5"
                layout="prev, pager, next"
                :total="pagination_list_count" >
                </el-pagination>
            </div>
        </div>
        <!-- 组合动作 -->
        <div class="group_list" v-if="group_status && tab_tab_init != 'public'">
            <!-- 素材分类组件 category -->
            <div class="category-type" v-show="!search_status">
                <div
                v-for="item, index in tab_left_pancel"
                :class="{'active':item.active}"
                @click="handleLeftPancelChange(index)">
                {{item.name}}
            </div>
        </div>
            <!-- 素材列表组件 list -->
            <div class="list" style="margin-left:30px;" v-show="!no_result" >
                <div class="con">
                    <div class="item " v-for="item in group_list" @click="handleGroupItem(item)">
                        <div v-show="item.type == 'folder'" class="folder">
                            <div class="pic"><img src="./folder.png"></div>
                            <div class="name">{{item.title}}</div>
                        </div>
                        <div v-show="item.type != 'folder'" class="file">
                            <div class="name" :title="item.title">{{item.title}}</div>
                            <div class="group" v-if="item.extdata && item.extdata.movable !== null">
                                <i class="icon-action_move" v-if="item.extdata.movable && item.extdata.looped"></i>
                                <i class="icon-action_circulation" v-if="item.extdata.looped === true && item.extdata.movable === false"></i>
                                <i class="icon-action_time" v-if="item.extdata.movable === false || item.extdata.looped === false"></i>
                                <span  v-if="item.extdata.movable === false || item.extdata.looped === false">{{item.extdata.duration.toFixed(2)}}秒</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="more" @click="handleMore" v-show="more">
                    <div class="inner">加载更多</div>
                </div> -->
            </div>
        </div>
        <!-- 组合动作 -->
        <div class="group_list" v-if="group_status && tab_tab_init == 'public'">
            <!-- 素材列表组件 list -->
            <div class="list" v-show="!no_result" >
                <div class="con">
                    <div class="item " v-for="item in group_list" @click="handleGroupItem(item)">
                        <div v-show="item.type == 'folder'" class="folder">
                            <div class="pic"><img src="./folder.png"></div>
                            <div class="name">{{item.title}}</div>
                        </div>
                        <div v-show="item.type != 'folder'" class="file">
                            <div class="name" :title="item.title">{{item.title}}</div>
                            <div class="group" v-if="item.extdata && item.extdata.movable !== null">
                                <i class="icon-action_move" v-if="item.extdata.movable && item.extdata.looped"></i>
                                <i class="icon-action_circulation" v-if="item.extdata.looped === true && item.extdata.movable === false"></i>
                                <i class="icon-action_time" v-if="item.extdata.movable === false || item.extdata.looped === false"></i>
                                <span  v-if="item.extdata.movable === false || item.extdata.looped === false">{{item.extdata.duration.toFixed(2)}}秒</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="more" @click="handleMore" v-show="more">
                    <div class="inner">加载更多</div>
                </div> -->
            </div>
        </div>
        <!-- 没有结果 -->
        <div class="no_results" v-show="no_result">
            <div class="pic">
                <img src="./no_result.png">
            </div>
            <div class="text">暂时还没有内容呦~^-^~</div>
        </div>
    </div>
</template>
<script>
// 通讯协议
import Protocol from "@/common/scripts/protocol.js";
// 工具类
import EUY from "@/common/scripts/euy.js";
import { eventBus } from "@/common/scripts/eventBus.js";
export default {
    // 组件
    components: {
    },
    // 数据
    data() {
        return {
            platform: this.$route.query.platform,
            loading: false,
            init: "",
            tab_type: "",
            // ------------------------------------------------- [ FLASH ] -------------------------------------------------
            // SWF 初始化配置
            // ----------------------------------------------------[ 搜索 ]---------------------------------------------
            search_key: "",
            no_result: false,
            // -------------------------------------------------- [ 标签切换 ] --------------------------------------------------
            // 数据
            tab_tab: [],
            // 初始值
            tab_tab_init: "public",
            //
            tab_left_pancel: [],
            // 初始值
            tab_left_pancel_init: "all",
            tab_category_init: "action",
            // -------------------------------------[ 列表数据 ]--------------------------------
            public_list_data: [],
            self_list_data: [],
            team_list_data: [],
            group_list: [],
            // 我的--团队--文件夹
            breadcrumb: [{ name: "根文件夹", folder_id: "/" }],
            //  ------------------------------------[ 分页数据 ]-----------------------------
            current_page: 1,
            page_size: 20,
            total: 0,
            more: false,
            // ----------------------------------------【 其他数据 】------------------------
            // p平台
            platform_type: "",
            // 公共市场-->分类id
            category_id: "",
            // 团队ID
            team_id: "",
            // 文件夹id
            folder_id: "",
            init: "",
            // 组合动画状态
            group_status: false,
            dialog_collect_visible: false,
            dialog_cancel_collect_visible: false,
            collect_time: null,
            ops_id: "",
            // 遮罩层
            mask_visible: true,
            // 已选动作名称
            select_action_tips: "",
            has_token: "",
            has_user_id: "",
            action_type: "",
            search_status: false,
            material_type: "",

            // 分页组件数据总数
            pagination_list_count:0,
            // last breadumb
            last_breadcrumb:[],
            //
            temp_data:[],
        };
    },
    methods: {
        // 搜索组件获得焦点
        searchInputFocus(){
            this.search_key=' '
        },
        searchInputBlur(){
            this.search_key=''
        },
        handleGroupHide() {
            this.group_status = false;
            this.handleCloseSearch();
        },
        // ----------------------------------------[ tab切换 ]---------------------------------------
        // 公共市场--我的--团队切换
        handleTabChange(index) {
            this.changeTab(index, this.tab_tab);
            this.tab_tab_init = this.tab_tab[index].type;
            console.log(this.tab_tab_init);
            this.group_status = false;

            // 目录清空
            (this.breadcrumb = [{ name: "根文件夹", folder_id: "/" }]),
            (this.folder_id = "");
            this.handleGetCategoryList();
        },
        // 素材分类切换
        handleLeftPancelChange(index) {
            if (this.tab_left_pancel_init != this.tab_left_pancel[index].id) {
                // 样式更改
                this.changeTab(index, this.tab_left_pancel);
                // category状态赋值
                this.tab_left_pancel_init = this.tab_left_pancel[index].id;
                // 分类id赋值
                this.category_id = this.tab_left_pancel[index].id;
                // 数据重置
                this.current_page = 1;
                this.public_list_data = [];
                // 目录清空
                (this.breadcrumb = [{ name: "根文件夹", folder_id: "/" }]),
                (this.folder_id = "");
                // 更新列表数据
                this.handleActionListData(this.tab_category_init,this.page_size,this.current_page,this.category_id,this.folder_id,this.team_id,this.search_key);
            }
        },
        // 切换公共方法
        changeTab(index, data) {
            for (let i = 0; i < data.length; i++) {
                data[i].active = false;
            }
            data[index].active = true;
        },
        // -----------------------------------[ 搜索 ]-------------------------------------------
        // 开始搜索
        handdleStartSearch(index) {
            if (this.group_status) {
            } else {
                this.search_status = true;
                // 公共市场--我的--团队 数据清空
                this.public_list_data = [];
                this.self_list_data = [];
                this.team_list_data = [];
                this.current_page = 1;

                // 更新列表数据
                if (index == 1) {
                    this.category_id = "";
                    this.last_breadcrumb = this.breadcrumb
                    // 清空文件路径
                    this.breadcrumb = []
                }
                this.handleActionListData(
                    this.tab_category_init,
                    this.page_size,
                    this.current_page,
                    this.category_id,
                    this.folder_id,
                    this.team_id,
                    this.search_key
                );
            }
        },
        // 关闭搜索
        handleCloseSearch(index) {
            this.search_key = "";
            // 更新列表数据
            this.handdleStartSearch();
            this.search_status = false;
            if(index == 1){
                if(this.last_breadcrumb){
                    this.breadcrumb = this.last_breadcrumb
                    this.last_breadcrumb = []
                    if(this.tab_left_pancel_init == "buy"){
                        this.breadcrumb = [{ name: "根文件夹", folder_id: "/" }]
                    }
                }
            }
        },
        // 加载更多
        handleMore() {
            this.current_page++;
            // 更新列表数据
            this.handleActionListData(
                this.tab_category_init,
                this.page_size,
                this.current_page,
                this.category_id,
                this.folder_id,
                this.team_id,
                this.search_key
            );
        },
        // -------------------------------------------------[ 单条数据操作 ]---------------------------------------
        // 鼠标按下
        handlePublicItemDown(item, ev) {
            // 判断右键
            if (ev.button == 2) {
                // 屏蔽右键
                document.oncontextmenu = function() {
                    return false;
                };
            }
            // 气泡和道具没有收藏功能
            if (this.action_type == "bubble" || this.action_type == "prop") {
            } else {
                this.collect_time = setTimeout(() => {
                    if (this.tab_left_pancel_init == "collect") {
                        this.ops_id = item.matterId;
                    } else {
                        this.ops_id = item.id;
                    }

                    if ("public" == this.tab_tab_init) {
                        if (item.isFav) {
                            this.dialog_cancel_collect_visible = true;
                            eventBus.$emit("dialogOpen", {
                                dialog_cancel_collect_visible: true,
                                component_name: "action"
                            });
                        } else {
                            this.dialog_collect_visible = true;
                            eventBus.$emit("dialogOpen", {
                                dialog_collect_visible: true,
                                component_name: "action"
                            });
                        }
                    }
                }, 500);
            }
        },

        // 鼠标抬起
        handlePublicItemUp(item, ev) {
            // 判断右键
            if (ev.button == 2) {
                // 屏蔽右键
                document.oncontextmenu = function() {
                    return false;
                };
            } else {
                // 左键
                clearInterval(this.collect_time);
                // 更换素材
                this.handleChangeMaterial(item.oriDataId);
                this.select_action_tips = item.title;
            }
        },
        // 确认收藏
        handleCollect() {
            this.dialog_collect_visible = false;
            this.handlePostCollectMatter(this.ops_id, "action");
        },
        // 确认取消收藏
        handleCancelCollect() {
            this.dialog_cancel_collect_visible = false;
            this.handlePostCancelCollectMatter(this.ops_id, "action");
        },
        // 我的
        handleSelfTeamItem(item) {
            if (item.type == "folder") {
                let name = item.title;
                this.folder_id = item.id;
                this.breadcrumb.push({
                    name: name,
                    folder_id: this.folder_id
                });
                this.handleCloseSearch();
            }else if(item.type == "package"){
                // 显示文件夹
                let name = item.title;
                this.folder_id = item.id;
                this.breadcrumb.push({
                    name: name,
                    folder_id: this.folder_id
                });

                if (this.tab_tab_init == 'team'){
                    if (this.group_status) {
                        if (this.tab_left_pancel_init == "buy") {
                            this.handleGetGroupTeamPackageDataList(this.team_id,this.page_size,this.current_page,this.search_key,item.packageId);
                        }
                    } else {
                        // if (this.tab_left_pancel_init == "creat") {
                        //     this.handleGetTeamActionListData(this.tab_category_init,page_size,current_page,folder_id,team_id,search_key);
                        // }
                        if (this.tab_left_pancel_init == "buy") {
                            this.handleGetTeamPackageActionListData(this.tab_category_init,this.page_size,this.current_page,this.team_id,this.search_key,item.packageId);
                        }
                    }
                }
                else if (this.tab_tab_init == 'self'){
                    if (this.group_status) {
                        // if (this.tab_left_pancel_init == "creat") {
                        //     this.handleGetGroupSelfDataList(this.page_size,this.current_page,this.search_key);
                        // }
                        if (this.tab_left_pancel_init == "buy") {
                            this.handleGetGroupSelfPackageDataList(this.page_size,this.current_page,this.search_key,item.packageId);
                        }
                    } else {
                        // if (this.tab_left_pancel_init == "creat") {
                        //     this.handleGetSelfActionListDate(type,page_size,current_page,folder_id,search_key);
                        // }

                        if (this.tab_left_pancel_init == "buy") {
                            this.handleGetSelfPackageActionListDate(this.tab_category_init,this.page_size,this.current_page,this.search_key,item.packageId);
                        }
                    }
                }
            }
            else {
                let itemId = item.dataId ? item.dataId : item.id
                // 更换素材
                this.handleChangeMaterial(itemId);
                this.select_action_tips = item.title;
            }
        },
        // 目录跳转
        handleTargetNav(index, folder_id) {
            this.current_page = 1;
            let arr = [];
            for (let i = 0; i < this.breadcrumb.length; i++) {
                if (i <= index) {
                    arr.push(this.breadcrumb[i]);
                }
            }
            this.breadcrumb = arr;
            if (folder_id == "/") {
                this.folder_id = "";
                // 更新列表数据
                this.handleActionListData(this.tab_category_init,this.page_size,this.current_page,this.category_id,this.folder_id,this.team_id,this.search_key);

            } else {
                this.folder_id = folder_id;
                // 更新列表数据
                this.handleActionListData(this.tab_category_init,this.page_size,this.current_page,this.category_id,this.folder_id,this.team_id,this.search_key);

            }
        },
        // -------------------------------------------------[  api  ]-----------------------------------------------
        // 列表同意处理
        handleActionListData(type,page_size,current_page,category_id,folder_id,team_id,search_key) {
            this.loading = true;
            this.more = false;

            if (this.action_type == "bubble" || this.action_type == "prop") {
                this.group_status = false;
            }
            // 公共市场
            if (this.tab_tab_init == "public") {
                if (this.action_type == "bubble" || this.action_type == "prop") {
                    //category_id = 14 为单图片动作
                    this.handleGetPublicActionListDate(type,page_size,current_page,"14",search_key);
                } else {
                    if (this.tab_left_pancel_init == "collect") {
                        // 收藏
                        this.handleGetPublicActionFavoriteListDate(type,page_size,current_page,search_key);
                    } else {
                        // 其他
                        this.handleGetPublicActionListDate(type,page_size,current_page,category_id,search_key);
                    }
                }
            }
            // 我的
            if (this.tab_tab_init == "self") {
                if (this.group_status) {
                    if (this.tab_left_pancel_init == "creat") {
                        this.handleGetGroupSelfDataList(this.page_size,this.current_page,this.search_key);
                    }
                    if (this.tab_left_pancel_init == "buy") {
                        // this.handleGetGroupSelfPackageDataList(this.page_size,this.current_page,this.search_key);

                        if (search_key.length > 0 | this.current_page > 1){
                            this.handleGetGroupSelfPackageDataList(this.page_size,this.current_page,this.search_key);
                        }else{
                            this.handleGetBuyActionListData('action', this.page_size, this.current_page, this.search_key, '',folder_id)
                        }
                    }
                } else {
                    if (this.tab_left_pancel_init == "creat") {
                        this.handleGetSelfActionListDate(type,page_size,current_page,folder_id,search_key);
                    }

                    if (this.tab_left_pancel_init == "buy" ) {
                        // this.handleGetSelfPackageActionListDate(type,page_size,current_page,search_key);

                        if (search_key.length > 0 | this.current_page > 1){
                            this.handleGetSelfPackageActionListDate(type,page_size,current_page,search_key);
                        }else{
                            this.handleGetBuyActionListData('action', page_size, current_page, search_key, '',folder_id)
                        }
                    }
                }
            }
            // 团队
            if (this.tab_tab_init == "team") {
                if (this.group_status) {
                    if (this.tab_left_pancel_init == "creat") {
                        this.handleGetGroupTeamDataList(this.team_id,this.page_size,this.current_page,this.search_key);
                    }
                    if (this.tab_left_pancel_init == "buy") {
                        // this.handleGetGroupTeamPackageDataList(this.team_id,this.page_size,this.current_page,this.search_key);

                        if (search_key.length > 0 | this.current_page > 1 ){

                            this.handleGetGroupTeamPackageDataList(this.team_id,this.page_size,this.current_page,this.search_key);
                        }else{

                            this.handleGetBuyActionListData('action', this.page_size, this.current_page, this.search_key, this.team_id,folder_id)
                        }
                    }
                } else {
                    if (this.tab_left_pancel_init == "creat") {

                        this.handleGetTeamActionListData(type,page_size,current_page,folder_id,team_id,search_key);
                    }

                    if (this.tab_left_pancel_init == "buy") {
                        if (search_key.length > 0 | this.current_page > 1){

                            this.handleGetTeamPackageActionListData(type,page_size,current_page,team_id,search_key);
                        }else{

                            this.handleGetBuyActionListData('action', page_size, current_page, search_key, team_id,folder_id)
                        }
                    }
                }
            }
        },
        // 动作列表-->公共市场
        handleGetPublicActionListDate(type, page_size,current_page,category_id,search_key) {
            let URL = process.env.HOST + "/api/storage/market/matters";
            let headers = {
                Authorization: this.has_token
            };
            let params = {
                type: type,
                page: current_page,
                pageSize: page_size,
                categoryId: category_id,
                keyword: search_key,
            };
            // 如果遮罩层显示 就不需要去请求数据了
            if(this.mask_visible && this.temp_data.length >0) {
                this.loading = false
                this.public_list_data = this.temp_data
                return
            }
            this.AJAX.get(URL, headers, params).then(data => {
                // console.log('动作列表-->公共市场 === 1 ' + JSON.stringify(data))
                if(data.code === 10000){
                    // 分页数据总数
                    this.pagination_list_count = data.datas.total
                }
                setTimeout(() => {
                    this.loading = false;
                }, 500);
                // 第一页数据为空
                if (current_page == 1 && data.datas.rows.length == 0) {
                    this.no_result = true;
                    this.more = false;
                } else {
                    // 正常数据处理
                    this.no_result = false;
                    this.public_list_data = data.datas.rows;
                    this.temp_data = data.datas.rows
                }
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // 素材列表-->公共市场-->收藏
        handleGetPublicActionFavoriteListDate(type,page_size,current_page,search_key) {
            let URL = process.env.HOST + "/api/storage/market/matters/favorites";

            let headers = {
                Authorization: this.has_token
            };
            let params = {
                type: type,
                page: current_page,
                pageSize: page_size,
                keyword: search_key
            };
            this.AJAX.get(URL, headers, params).then(data => {
                if(data.code == 10000){
                    // 分页数据总数
                    this.pagination_list_count = data.datas.total
                }
                setTimeout(() => {
                    this.loading = false;
                }, 500);

                // 第一页数据为空
                if (current_page == 1 && data.datas.rows.length == 0) {
                    this.no_result = true;
                    this.more = false;
                } else {
                    // 正常数据处理
                    this.no_result = false;
                    this.public_list_data = data.datas.rows;
                    if (data.datas.rows.length >= this.page_size) {
                        this.more = true;
                        return false;
                    } else {
                        this.more = false;
                        return false;
                    }
                }
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // 素材市场-->我的
        handleGetSelfActionListDate(type,page_size,current_page,folder_id,search_key) {
            let URL = process.env.HOST + "/api/storage/storage/resource/v1/list";

            let headers = {
                Authorization: this.has_token
            };
            let params = {
                type: type,
                page: current_page,
                pageSize: page_size,
                folderId: folder_id,
                keyword: search_key
            };
            this.AJAX.get(URL, headers, params).then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);
                if(data.code === 10000){
                    // 分页数据总数
                    this.pagination_list_count = data.datas.total
                }
                // 第一页数据为空
                if (current_page == 1 && data.datas.rows.length == 0) {
                    this.no_result = true;
                    this.more = false;
                } else {
                    // 正常数据处理
                    this.no_result = false;
                    this.self_list_data = data.datas.rows;
                    if (data.datas.rows.length >= this.page_size) {
                        this.more = true;
                        return false;
                    } else {
                        this.more = false;
                        return false;
                    }
                }
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        handleGetSelfPackageActionListDate(type, page_size, current_page, search_key, package_id) {
            let URL = process.env.HOST;
            if(package_id){
                URL += "/api/storage/market/packages/" + package_id + "/resources";
            }else{
                URL += "/api/storage/market/packages/resources";
            }

            let headers = {
                Authorization: this.has_token
            };

            let params = {
                page: current_page,
                pageSize: page_size,
                keyword: search_key,
                type: type
            };
            // console.log("动作的参数 => " + JSON.stringify(params))
            this.AJAX.get(URL, headers, params).then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);
                if(data.code == 10000){
                    // 分页数据总数
                    this.pagination_list_count = data.datas.total
                }
                // 第一页数据为空
                if (current_page == 1 && data.datas.rows.length == 0) {
                    this.no_result = true;
                    this.more = false;
                } else {
                    // 正常数据处理
                    this.no_result = false;
                    // 第一页数据特殊处理
                    if (current_page == 1) {
                        this.self_list_data = data.datas.rows;
                    } else {
                        // 加载更多正常处理
                        // this.self_list_data = this.self_list_data.concat(
                        //     data.result.data
                        // );
                        this.self_list_data = data.datas.rows;
                    }
                    if (data.datas.rows.length >= this.page_size) {
                        this.more = true;
                        return false;
                    } else {
                        this.more = false;
                        return false;
                    }
                }
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // 素材市场-->团队
        handleGetTeamActionListData(type,page_size,current_page,folder_id,team_id,search_key) {
            let URL = process.env.HOST + "/api/storage/storage/resource/v1/list";

            let headers = {
                Authorization: this.has_token
            };
            let params = {
                type: type,
                page: current_page,
                pageSize: page_size,
                folderId: folder_id,
                keyword: search_key,
                teamId: team_id
            };
            // 如果遮罩层显示 就不需要去请求数据了
            if(this.mask_visible && this.temp_data.length >0) {
                this.loading = false
                this.team_list_data = this.temp_data
                return
            }
            this.AJAX.get(URL, headers, params).then(data => {
                if(data.code === 10000){
                    // 分页数据总数
                    this.pagination_list_count = data.datas.total
                }
                setTimeout(() => {
                     this.loading = false;
                }, 500);
                // 第一页数据为空
                if (current_page == 1 && data.datas.rows.length == 0) {
                    this.no_result = true;
                    this.more = false;
                } else {
                    // 正常数据处理
                    this.no_result = false;
                    this.team_list_data = data.datas.rows;
                    this.temp_data = data.datas.rows;
                    if (data.datas.rows.length >= this.page_size) {
                        this.more = true;
                        return false;
                    } else {
                        this.more = false;
                        return false;
                    }
                }
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },

        //  统一处理我的-团队 购买的动作
        handleGetBuyActionListData (type, page_size, current_page, search_key, team_id ,folder_id) {
            let URL = process.env.HOST + '/api/storage/market/packages/purchased'
            let headers = {'Authorization': this.has_token}
            var params = {
                    'page': current_page,
                    'pageSize': page_size,
                    'keyword': search_key,
                    'teamId': team_id,
                    'type': type
                }

            this.AJAX.get(URL, headers, params).then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);

                if(data.code == 10000){
                    // 分页数据总数
                    this.pagination_list_count = data.datas.total
                }
                // 第一页数据为空
                if (current_page == 1 && data.datas.rows.length == 0) {
                    this.no_result = true;
                    this.more = false;
                } else {
                    // 正常数据处理
                    this.no_result = false;
                    // 第一页数据特殊处理
                    if (current_page == 1) {
                        var count = 0
                        for (var i = 0;i < data.datas.rows.length;i ++){
                            if (data.datas.rows[i].count == 0){
                                count += 1
                            }
                        }
                        if (count == data.datas.rows.length){
                            this.no_result = true
                        }else{
                            if (team_id.length > 0){
                                this.team_list_data = data.datas.rows;
                            }else {
                                this.self_list_data = data.datas.rows;
                            }
                        }
                    } else {
                        // 加载更多正常处理
                        if (team_id.length > 0){
                            // this.team_list_data = this.team_list_data.concat(
                            //     data.result.data
                            // );
                            this.team_list_data = data.datas.rows;
                        }else {
                            // this.self_list_data = this.self_list_data.concat(
                            //             data.result.data
                            // );
                            this.self_list_data = data.datas.rows;
                        }
                    }
                    if (data.datas.rows.length >= this.page_size) {
                        this.more = true;
                        return false;
                    } else {
                        this.more = false;
                        return false;
                    }
                }
            }).catch(err => {
                    this.$message({
                        message: err.msg||err.message,
                        type: "error"
                    });
                });
        },

        handleGetTeamPackageActionListData(type, page_size, current_page, team_id, search_key, package_id) {
            let URL = process.env.HOST;
            if (package_id) {
                URL += "/api/storage/market/packages/"+package_id+"/resources";
            }else{
                URL += "/api/storage/market/packages/resources";
            }

            let headers = {
                Authorization: this.has_token
            };
            let params = {
                type: type,
                page: current_page,
                pageSize: page_size,
                keyword: search_key,
                teamId: team_id,
            };
            this.AJAX.get(URL, headers, params).then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);
                // console.log('eeee ===> ' + JSON.stringify(params) + '========' +JSON.stringify(data))
                if(data.code === 10000){
                    // 分页数据总数
                    this.pagination_list_count = data.datas.total
                }
                // 第一页数据为空
                if (current_page == 1 && data.datas.rows.length == 0) {
                    this.no_result = true;
                    this.more = false;
                } else {
                    // 正常数据处理
                    this.no_result = false;
                    this.team_list_data = data.datas.rows;
                    if (data.datas.rows.length >= this.page_size) {
                        this.more = true;
                        return false;
                    } else {
                        this.more = false;
                        return false;
                    }
                }
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // 获取素材分类列表
        handleGetCategoryList() {
            this.tab_left_pancel = [];

            if (this.tab_tab_init == "public") {
                let URL = process.env.HOST + "/api/storage/market/categories";

                let headers = {
                    Authorization: this.has_token
                };
                let params = {
                    type: 'action'
                };
                this.AJAX.get(URL, headers, params).then(data => {
                    // console.log('动作 - public => ' + JSON.stringify(data))
                    // 初始左侧导航赋值
                    let prop = 'prop'
                    let bubble = 'bubble'
                    let action = 'action'
                    let collect = (this.material_type == prop || this.material_type == bubble)?"":"收藏"
                    this.tab_left_pancel = [
                        {
                            name: collect,
                            active: false,
                            id: "collect"
                        }
                    ];
                    if (0 < data.datas.rows.length) {
                        this.tab_left_pancel[0].active = false;
                        data.datas.rows[0].active = true;
                        this.tab_left_pancel_init = "all";
                        this.category_id = data.datas.rows[0].id;
                    }
                    if(this.material_type == prop){
                        this.action_type = prop
                    }else if (this.material_type == bubble){
                        this.action_type = bubble
                    }else{
                        this.action_type = action
                        this.tab_left_pancel = this.tab_left_pancel.concat(data.datas.rows);
                    }
                    this.handleCloseSearch();
                    // console.log('handleGetCategoryList == > '  + JSON.stringify(data))
                }).catch(err => {
                    this.$message({
                        message: err.msg||err.message,
                        type: "error"
                    });
                });
            }else if (this.tab_tab_init == "self") {
                this.handleGetSelfPackageStatus();
            }else if (this.tab_tab_init == "team") {
                this.handleGetTeamPackageStatus(this.team_id);
            }
        },

        // 查看我的是否有素材包动作
        handleGetSelfPackageStatus() {
            let URL = process.env.HOST + "/api/storage/market/packages/purchased"
            let headers = {
                Authorization: this.has_token
            };

            let params = {
                page: "1",
                pageSize: "10",
                keyword: "",
                type: "action"
            };

            this.AJAX.get(URL, headers, params).then(data => {
                // console.log('动作 - self => ' + JSON.stringify(data))
                if (data.datas.rows.length > 0) {
                    this.tab_left_pancel = [
                        {
                            name: "创建的",
                            active: true,
                            id: "creat"
                        },
                        {
                            name: "购买的",
                            active: false,
                            id: "buy"
                        }
                    ];

                    this.tab_left_pancel_init = "creat";
                } else {
                    this.tab_left_pancel = [
                        {
                            name: "创建的",
                            active: true,
                            id: "creat"
                        }
                    ];

                    this.tab_left_pancel_init = "creat";
                }
                // 给购买的数据赋值
                this.buy_list_data = data
                // 渲染数据
                this.handleCloseSearch();
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },

        // 查看团队的是否有素材包
        handleGetTeamPackageStatus(team_id) {
            let URL = process.env.HOST + "/api/storage/market/packages/purchased"
            let headers = {
                Authorization: this.has_token
            };

            let params = {
                page: "1",
                pageSize: "10",
                keyword: "",
                teamId: team_id,
                type: "action"
            };

            this.AJAX.get(URL, headers, params).then(data => {
                // console.log('动作 - team => ' + JSON.stringify(data))
                if (data.datas.rows.length > 0) {
                    this.tab_left_pancel = [
                        {
                            name: "创建的",
                            active: true,
                            id: "creat"
                        },
                        {
                            name: "购买的",
                            active: false,
                            id: "buy"
                        }
                    ];

                    this.tab_left_pancel_init = "creat";
                } else {
                    this.tab_left_pancel = [
                        {
                            name: "创建的",
                            active: true,
                            id: "creat"
                        }
                    ];

                    this.tab_left_pancel_init = "creat";
                }
                // 给购买的数据赋值
                this.buy_list_data = data
                // 渲染数据
                this.handleCloseSearch();
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // 更换素材
        handleChangeMaterial(ori_data_id) {
            let platform = this.$route.query.platform;
            // protobuf 打包
            let MMaterial = new proto.com.proto.material.MMaterial();
            let MMaterialType = null;

            MMaterialType = "action";
            // protobuf 打包格式
            MMaterial.setType(MMaterialType);
            MMaterial.setId(ori_data_id);
            // 素材市场资源标记为public：eu-core跳过getCzById(团队权限610002)直走CDN
            if (this.tab_tab_init == 'public' && window.EuCoreEngine && window.EuCoreEngine.markPublicResource) {
                window.EuCoreEngine.markPublicResource(ori_data_id);
            }
            // protobuf 序列化
            let protoBytes = MMaterial.serializeBinary();

            // Uint8Array 转换 Array
            let protoBytesArray = Array.from(protoBytes);
            let material_scene_3_1 = {
                packageId: 0,
                senderId: ACTION,
                senderName: ACTION_NAME,
                receiverId: SCENE,
                receiverName: SCENE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 3,
                messageId: MESSAGE_ID_MATERIAL_SCENE_3_1,
                protoBytesType: "proto.com.proto.material.MMaterial",
                protoBytes: protoBytesArray
            };
            // 发送消息
            Protocol.sender(platform, material_scene_3_1);

            if (this.tab_type == 2) {
                let action_core_1_20 = {
                    packageId: 0,
                    senderId: ACTION,
                    senderName: ACTION_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: MESSAGE_ID_ACTION_CORE_1_20,
                    protoBytesType: "proto.com.proto.s.MUint32",
                    protoBytes: Protocol.serializeBinary(
                        new proto.com.proto.s.MUint32(),
                        {
                            setValue: ACTION
                        }
                    )
                };

                // 发送消息
                Protocol.sender(platform, action_core_1_20);
            }
        },
        handleGroupItem(item) {
            if (this.tab_tab_init == "public") {
                this.handleChangeMaterial(item.dataId);
            } else {
                this.handleChangeMaterial(item.id);
            }

        },
        handleGetGroupStatus() {},
        // 我的动作
        handleGetGroupSelfDataList(page_size, current_page, search_key) {
            let URL = process.env.HOST + "/api/storage/storage/resource/v1/list";

            let headers = {
                Authorization: this.has_token
            };
            let params = {
                pageSize: page_size,
                page: current_page,
                keyword: search_key,
                type: "action"
            };
            this.AJAX.get(URL, headers, params).then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);

                this.group_list = data.datas.rows;
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        handleGetGroupSelfPackageDataList(page_size, current_page, search_key,package_id) {
            let URL = process.env.HOST + "/api/storage/market/packages/" + package_id + "/resources";

            let headers = {
                Authorization: this.has_token
            };
            let params = {
                pageSize: page_size,
                page: current_page,
                keyword: search_key,
                type: "action",
                //fina: "0",
            };
            this.AJAX.get(URL, headers, params).then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);

                this.group_list = data.datas.rows;
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // 组合动画--->团队
        handleGetGroupTeamDataList(team_id, page_size, current_page, search_key) {
            let URL = process.env.HOST + "/pro/api/action/myUnion";

            let headers = {
                token: this.has_token
            };
            let params = {
                team_id: team_id,
                page_size: page_size,
                current_page: current_page,
                search_key: search_key
            };
            this.AJAX
            .get(URL, headers, params)
            .then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);

                this.group_list = data.result.data;
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        handleGetGroupTeamPackageDataList(team_id,page_size,current_page,search_key,package_id) {
            let URL = process.env.HOST + "/api/storage/market/packages/"+package_id+"/resources";

            let headers = {
                Authorization: this.has_token
            };
            let params = {
                teamId: team_id,
                pageSize: page_size,
                page: current_page,
                keyword: search_key,
                type: "action",
            };
            this.AJAX.get(URL, headers, params).then(data => {
                setTimeout(() => {
                    this.loading = false;
                }, 500);

                this.group_list = data.datas.rows;
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // api--post--收藏素材
        handlePostCollectMatter(id, type) {
            let URL = process.env.HOST + "/api/storage/market/matters/favorites";

            let params = {
                matterId: id,
                type: type,
            };
            let headers = {
                Authorization: this.has_token,
            };
            this.AJAX.post(URL, headers, params).then(data => {
                this.$message({
                    message: "收藏成功",
                    type: "success"
                });
                this.current_page = 1;
                this.handleActionListData(
                    this.tab_category_init,
                    this.page_size,
                    this.current_page,
                    this.category_id,
                    this.folder_id,
                    this.team_id,
                    this.search_key
                );
            }).catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // api--post--取消收藏
        handlePostCancelCollectMatter(id, type) {
            let URL = process.env.HOST + "/api/storage/market/matters/favorites/delete";

            let params = {
                matterId: id,
                type: type,
            };
            let headers = {
                Authorization: this.has_token,
            };
            this.AJAX.post(URL, headers, params).then(data => {
                this.$message({
                    message: "取消成功",
                    type: "success"
                });

                this.current_page = 1;
                this.handleActionListData(
                    this.tab_category_init,
                    this.page_size,
                    this.current_page,
                    this.category_id,
                    this.folder_id,
                    this.team_id,
                    this.search_key
                );
            })
            .catch(err => {
                this.$message({
                    message: err.msg||err.message,
                    type: "error"
                });
            });
        },
        // 分页组件点击
        handleCurrentChange(page){
            // this.handleMore()
            // console.log('分页组件点击 ==> '+page )
            this.current_page = page == 1?2:page
            // 更新列表数据
            this.handleActionListData(this.tab_category_init,this.page_size,page,this.category_id,this.folder_id,this.team_id,this.search_key);
        },
    },
    computed: {
        // 搜索隐藏
        searchHide() {
            if (this.action_type == "bubble" || this.action_type == "prop") {
                if (this.tab_tab_init == "public") {
                    return "search-hide";
                }
                if (this.tab_tab_init == "self" || this.tab_tab_init == "team") {
                }
            }
            if (this.group_status) {
                return "search-hide";
            }
        },
        // 道具--气泡--我的--团队--列表位置
        positionTop() {
            if (this.action_type == "bubble" || this.action_type == "prop") {
                return "postion-top100";
            }
        },
        // 道具--气泡--我的--团队--列表位置
        positionWidth() {
        },
        // 道具--气泡--公共市场--列表位置
        positionTop1() {
            if (this.action_type == "bubble" || this.action_type == "prop") {
                return "postion-top60";
            }
        },
        // 搜索隐藏左侧daohang
        hideLeft() {
            if (this.search_status || this.tab_left_pancel.length <= 1) {
                return "position-left0";
            }else if(this.breadcrumb.length > 1){
                console.log('postion-top30')
                return "postion-top30";
            }
        }
    },

    created() {
        eventBus.$on("handleCollect_action", target => {
            this.handleCollect();
        });
        eventBus.$on("handleCancelCollect_action", target => {
            this.handleCancelCollect();
        });
    },

    watch: {
        search_key: function() {
            // this.search_key = this.search_key.replace(/(^\s*)|(\s*$)/g, "");
            if (this.search_key == "") {
                if (this.search_status) {
                    this.handleCloseSearch();
                }
            }
        }
    },

    // 渲染
    mounted() {
        let platform = this.$route.query.platform;
        let _this = this;
        // ACTION
        // 模块初始化
        Protocol.onSocketInit(platform, ACTION_NAME, ACTION);

        // 模块与服务器建立链接
        Protocol.onSocketConnect(platform, ACTION_NAME);
        // 模块与服务器建立链接
        Protocol.onSocketRegister(platform, ACTION_NAME, ACTION);
        // 接收消息
        Protocol.receiver(platform, ACTION_NAME);
        window[ACTION_NAME].domReady = () => {
            //请求用户数据
            let action_core_1_3 = {
                packageId: 0,
                senderId: ACTION,
                senderName: ACTION_NAME,
                receiverId: CORE,
                receiverName: CORE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 1,
                messageId: MESSAGE_ID_ACTION_CORE_1_3,
                protoBytesType: "",
                protoBytes: []
            };
            // 发送消息
            Protocol.sender(platform, action_core_1_3);
            //请求Token
            let action_core_1_1 = {
                packageId: 0,
                senderId: ACTION,
                senderName: ACTION_NAME,
                receiverId: CORE,
                receiverName: CORE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 1,
                messageId: MESSAGE_ID_ACTION_CORE_1_1,
                protoBytesType: "proto.com.proto.s.MToken",
                protoBytes: []
            };
            // 发送消息
            Protocol.sender(platform, action_core_1_1);
            //请求当前tab数据
            let action_core_1_11 = {
                packageId: 0,
                senderId: ACTION,
                senderName: ACTION_NAME,
                receiverId: CORE,
                receiverName: CORE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 1,
                messageId: MESSAGE_ID_ACTION_CORE_1_11,
                protoBytesType: "",
                protoBytes: []
            };
            // 发送消息
            Protocol.sender(platform, action_core_1_11);
            // 检查场景是否加载完成
            let action_scene_6_26 = {
                packageId: 0,
                senderId: ACTION,
                senderName: ACTION_NAME,
                receiverId: SCENE,
                receiverName: SCENE_NAME,
                timeFlag: new Date().getTime(),
                sessionId: 6,
                messageId: MESSAGE_ID_ACTION_SCENE_6_26,
                protoBytesType: "",
                protoBytes: []
            };
            // 发送消息
            Protocol.sender(platform, action_scene_6_26);
        };
        window[ACTION_NAME].message = (
            senderId,
            packageId,
            sessionId,
            messageId,
            protoBytes
        ) => {
            if (sessionId == 6 && messageId == 5) {
                _this.init = "complete";

                console.log("[" + ACTION_NAME + "][COMPLETE]");

                //请求选择的对象
                let action_scene_6_4 = {
                    packageId: 0,
                    senderId: ACTION,
                    senderName: ACTION_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: MESSAGE_ID_ACTION_SCENE_6_4,
                    protoBytesType: "",
                    protoBytes: []
                };
                // 发送消息
                Protocol.sender(platform, action_scene_6_4);
            }
            // 同步团队型信息
            if (sessionId == 1 && messageId == 12) {
                let is_team = Protocol.deserializeBinary(
                    "proto.com.proto.s.MTabData",
                    protoBytes
                ).array;
                _this.tab_type = is_team[0];
                if (is_team[4]) {
                    _this.tab_tab = [
                        {
                            name: is_team[5],
                            active: true,
                            type: "team"
                        },
                        {
                            name: "公共市场",
                            active: false,
                            type: "public"
                        },
                        {
                            name: "我的",
                            active: false,
                            type: "self"
                        }
                    ];
                    _this.tab_tab_init = "team";
                    _this.team_id = is_team[4];
                } else {
                    _this.tab_tab = [
                        {
                            name: "公共市场",
                            active: true,
                            type: "public"
                        },
                        {
                            name: "我的",
                            active: false,
                            type: "self"
                        }
                    ];
                    _this.tab_tab_init = "public"
                }

                _this.loading = true
                _this.public_list_data = []
                _this.self_list_data = []
                _this.team_list_data = []
            }
            // 同步用户信息--id
            if (sessionId == 1 && messageId == 4) {
                let arr = Protocol.deserializeBinary(
                    "proto.com.proto.s.UserInfo",
                    protoBytes
                ).array;
                _this.has_user_id = arr[3][0];
            }
            // 同步token
            if (sessionId == 1 && messageId == 2) {
                let is_token = Protocol.deserializeBinary(
                    "proto.com.proto.s.MToken",
                    protoBytes
                ).array;
                _this.has_token = is_token[0];
            }
            // 选择形象消息
            if (sessionId == 6 && messageId == 1) {
                let isSelect = Protocol.deserializeBinary(
                    "proto.com.proto.scene.MSelected",
                    protoBytes
                ).array;
                console.log("ACTION - ", JSON.stringify(isSelect) + _this.material_type);
                if(isSelect[0]){
                    _this.mask_visible = false;
                    if(_this.material_type != isSelect[1][0][1]){
                        _this.temp_data = []
                        _this.material_type = isSelect[1][0][1]
                        _this.handleGetCategoryList();
                    }
                    else{
                        // 解决从动作编辑器回来，点击场景人物／道具／气泡无法加载动作的问题  2018/9/19
                        if(_this.tab_tab_init == 'public'){
                            if(_this.public_list_data.length == 0){
                                _this.handleGetCategoryList();
                            }
                        }else if(_this.tab_tab_init == 'team'){
                            if(_this.team_list_data.length == 0){
                                _this.handleGetCategoryList();
                            }
                        }else if(_this.tab_tab_init == 'self'){
                            if(_this.self_list_data.length == 0){
                                _this.handleGetCategoryList();
                            }
                        }

                        _this.loading = false
                    }
                } else {
                    _this.mask_visible = true;
                }
            }
            // 锁定模块
            if (sessionId == 1 && messageId == 13) {
                _this.mask_visible = true;
            }
            // 解除锁定
            if (sessionId == 1 && messageId == 14) {
                _this.mask_visible = false;
            }else if (sessionId == 1 && messageId == 21) {
                // 获取素材分类列表
                _this.handleGetCategoryList()

            }else if (sessionId == 1 && messageId == 32) {
                // 显示与隐藏遮罩
                let mBool = Protocol.deserializeBinary('proto.com.proto.s.MBool', protoBytes).toObject();
                _this.mask_visible = !mBool;
            }
        };
    }
};
</script>
<style lang="stylus" scoped>
.action {
  background: #505050//#e8e8e8;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  .title {
    background: #a6a6a6;
    line-height: 25px;
    text-align: center;
    color: #3f3f3f;
  }
  .mask_action {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 280px;
    background:rgba(58, 58, 58, 0.8);//rgba(255, 255, 255, 0.8);
    z-index: 100;
  }
  .loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 280px;
    height: 100%;
  }
  .select_action_tips {
    padding: 10px 0;
    -webkit-transform: scale(0.8);
    font-size: 12px;
    margin-left: -15px;
  }
  .tabs {
    display: flex;
    div {
      background:#3d3d3d//#f0f0f0;
      color: #fff;
      flex: 1;
      line-height: 25px;
      border: 1px solid #3d3d3d;
      text-align: center;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color: #fff//#2f2f2f;
      background: #505050//#e8e8e8;
      border-right:1px solid #3d3d3d
    }
  }
  .search {
    padding: 10px;
    position: relative;
    .search-inner {
      .text {
        border: 1px solid #e7e7e7;
        background: #fff;
        height: 25px;
        width: 100%;
        padding: 0 5px;
        box-sizing: border-box;
      }
      :disabled {
        border: 1px solid #e7e7e7;
        background: #eee;
        color: red !important;
      }
      .button {
        position: absolute;
        top: 10px;
        cursor: pointer;
      }
      .icon-search {
        right: 10px;
        color: #666;
        font-size: 24px;
      }
      .el-icon-close {
        top: 17px;
        right: 32px;
        &:hover {
          color: #717171;
        }
        &:active {
          color: #4A4A4A;
        }
      }
    }
  }
  .search-hide {
    display: none;
  }
  .category-nav {
    padding: 0 10px 10px 10px;
    height: 20px;
    div {
      float: left;
      height: 20px;
      line-height: 20px;
      background: #3d3d3d//#dbdbdb;
      font-size: 12px;
      padding: 0 5px;
      margin-right: 10px;
      border-radius: 3px;
      cursor: pointer;
    }
    .active {
      color: #e2e2e2//#fff;
      background: #505050//#7ab3f6;
      font-weight: bold;
    }
  }
  .public {
    position: absolute;
    top: 80px;
    right: 0;
    bottom: 0;
    left: 0;
    .category-type {
      position: absolute;
      background: #3d3d3d//#dbdbdb;
      color: #e2e2e2//#3d3d3d;
      width: 40px;
      top: 0;
      left: 0;
      bottom: 0;
      overflow: auto;
      // padding-top: 10px
      div {
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        span {
          display: block;
          font-size: 12px;
          -webkit-transform: scale(0.8);
        }
      }
      .active {
        background: #505050//#e8e8e8;
      }
    }
    .hide {
      display: none;
    }
    .list {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 40px;
      box-sizing: border-box;
      padding: 0 5px 5px 5px;
      overflow: auto;
      &.position {
        left: 0;
      }
      .con {
        overflow: hidden;
        .item {
          padding: 10px 5px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #e2e2e2//#666;
          margin: 0 5px 10px 5px;
          box-sizing: border-box;
          background: #626262//#dbdbdb;
          .group {
            position: absolute;
            right: 5px;
            top: 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -webkit-transform: scale(0.8);
            margin-left: -10px;
          }
          .name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -webkit-transform: scale(0.8);
            margin-left: -10px;
            color: #e2e2e2
          }
        }
      }
      .more {
        padding: 0 5px 5px 5px;
        .inner {
          padding: 10px;
          text-align: center;
          background: #fff;
        }
      }
    }
    .loadingMore {
        position:absolute
        margin-left:40px
        height:30px
        text-align:center
        background:#3d3d3d
        // background:red
        bottom:0px
        width:100%
        .pagination {
          position:relative
          background:#3d3d3d//green
          width:100%
          margin-top:0px
          margin-left:-25px
          -webkit-transform: scale(0.8)
          height:30px
        }
  }
    .position-left0 {
      left: 0;
    }
  }
  .private-team {
    position: absolute;
    top: 80px;
    right: 0;
    bottom: 0;
    left: 0;
    .category-type {
      position: absolute;
      background: #3d3d3d//#dbdbdb;
      color: #e2e2e2//#3d3d3d;
      width: 40px;
      top: 2px;
      left: 0;
      bottom: 0;
      overflow: auto;
      // padding-top: 10px
      div {
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background: #505050//#e8e8e8;
      }
    }
    .breadcrumb {
      margin-bottom: 10px;
      padding-left: 47px;
      padding-top: 5px;
      span {
        display: inline-block;
        padding-right: 5px;
        color: #20a0ff;
        cursor: pointer;
        height:15px;
      }
    }
    .list {
      position: absolute;
      top:6px;
      right: 0;
      bottom: 0;
      left: 40px;
      box-sizing: border-box;
      padding: 0 5px 5px 5px;
      overflow: auto;
      .con {
        overflow: hidden;
        .item {
          .folder {
            cursor: pointer;
            position: relative;
            padding: 10px;
            cursor: pointer;
            color: #666;
            margin: 0 5px 10px 5px;
            border: 1px solid #747474//#ccc;
            box-sizing: border-box;
            border-radius: 3px;
            font-size: 12px;
            .pic {
              position: absolute;
              top: 5px;
              left: 5px;
              img {
                width: 20px;
                height: 20px;
                margin: 0 auto;
                display: block;
              }
            }
            .name {
              padding-left: 20px;
              position: relative;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -webkit-transform: scale(0.8);
              margin-left: -5px;
              color:#e2e2e2;
            }
          }
          .file {
            padding: 10px 5px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #666;
            margin: 0 5px 10px 5px;
            box-sizing: border-box;
            background: #626262//#dbdbdb;
            .group {
              position: absolute;
              right: 5px;
              top: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -webkit-transform: scale(0.8);
              margin-left: -10px;

            }
            .name {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -webkit-transform: scale(0.8);
              margin-left: -10px;
              color:#e2e2e2;
            }
          }
        }
      }
    }
    .position-left0 {
      left: 0;
    }
    .position1 {
      top: 0;
    }
    .postion-top30 {
      top: 35px;
    }
  }
  .group_list {
    position: absolute;
    top: 82px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 5px 5px 5px;
    .list {
      position: absolute;
      top: 0px;
      right: 0;
      bottom: 0;
      left: 10px;
      box-sizing: border-box;
      padding: 0 5px 5px 5px;
      overflow: auto;
      .con {
        overflow: hidden;
        .item {
          .folder {
            cursor: pointer;
            position: relative;
            padding: 10px;
            cursor: pointer;
            color: #666;
            margin: 0 5px 10px 5px;
            border: 1px solid #ccc;
            box-sizing: border-box;
            border-radius: 3px;
            font-size: 12px;
            .pic {
              position: absolute;
              top: 5px;
              left: 5px;
              img {
                width: 20px;
                height: 20px;
                margin: 0 auto;
                display: block;
              }
            }
            .name {
              padding-left: 20px;
              position: relative;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -webkit-transform: scale(0.8);
              margin-left: -5px;
            }
          }
          .file {
            padding: 10px 5px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #666;
            margin: 0 5px 10px 5px;
            box-sizing: border-box;
            background: #dbdbdb;
            .group {
              position: absolute;
              right: 5px;
              top: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -webkit-transform: scale(0.8);
              margin-left: -10px;
            }
            .name {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -webkit-transform: scale(0.8);
              margin-left: -10px;
            }
          }
        }
      }
    }
    .category-type {
      position: absolute;
      background: #3d3d3d//#dbdbdb;
      color: #e2e2e2//#3d3d3d;
      width: 40px;
      top: 0px;
      left: 0;
      bottom: 0;
      overflow: auto;
      div {
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background: #505050//#e8e8e8;
      }
    }
    .package-item {
      float: left;
      .file {
        cursor: pointer;
        position: relative;
        width: 87px;
        padding: 10px;
        cursor: pointer;
        color: #666;
        margin: 0 5px 10px 5px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        border-radius: 3px;
        .name {
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -webkit-transform: scale(0.8);
        }
      }
    }
    .position-left0 {
      left: 0;
    }
  }
  .more {
    padding: 0 5px 5px 5px;
    .inner {
      padding: 10px;
      text-align: center;
      background: #fff;
    }
  }
  .loadingMore {
        position:absolute
        margin-left:40px
        height:30px
        background:#3d3d3d//#E8E8E8
        // background:green
        bottom:0px
        width:100%
        .pagination {
          position:relative
          background:#3d3d3d//red
          width:100%
          margin-top:0px
          margin-left:-25px
          -webkit-transform: scale(0.75)
          height:30px
        }
  }
  .no_results {
    width: 200px;
    position: absolute;
    left: 50px;
    margin-top:150px;
    .pic {
      width: 200px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    .text {
      text-align: center;
      margin-top: 20px;
      color:#fff;
    }
  }
  .postion-top100 {
    top: 100px;
  }
  .postion-top60 {
    top: 60px;
  }

}
</style>



// WEBPACK FOOTER //
// Action.vue?bd054faa